import React from 'react'

import Translator from 'bazinga-translator'
import { useUser } from 'containers/MainLayout/selectors'

import { PLAYER_VERIFICATION_STATUS_ADDRESS } from '../../../../../containers/App/constants'
import Btn from '../../../../Btn'
import PlayForFunButton from '../Play/PlayForFunButton'
import { ButtonsWrapper } from './styles/ButtonsWrapper'

interface Props {
  realPlayUrl: string
  forFunPlayUrl: string
  small?: boolean
}

function LoggedInButtons({ realPlayUrl, forFunPlayUrl, small }: Props) {
  const user = useUser()

  const isPlayForFunPermitted = !!user?.isPlayForFunPermitted
  const isRealPlayPermitted = !!user?.isRealPlayPermitted || !!user?.fullyActivated

  return (
    <ButtonsWrapper>
      {isRealPlayPermitted ? (
        <Btn
          xl={!small}
          svg
          secondary
          href={realPlayUrl}
        >
          {Translator.trans('play_for_real', {}, 'games')}
        </Btn>
      ) : (
        <Btn
          danger
          to={PLAYER_VERIFICATION_STATUS_ADDRESS}
        >
          {Translator.trans('your_account_is_limited', {}, 'users')}
        </Btn>
      )}
      <PlayForFunButton
        forFunPlayUrl={forFunPlayUrl}
        condition={isPlayForFunPermitted}
      />
    </ButtonsWrapper>
  )
}

export default LoggedInButtons
